import { useEffect, useState } from 'react';
import InboundIcon from '../../../Icons/InboundIcon';
import { useTelephonyContext } from '../../../../../contexts/TelephonyContext';
import { getVoiceContact } from '../../../../../utils/getVoiceContact';
import { Box, Typography } from '@coolblue-development/freddy';

const ContactQueue = (): JSX.Element => {
  const { voiceContact } = useTelephonyContext();
  const [contactQueue, setContactQueue] = useState<string>('');
  const [isInbound, setIsInbound] = useState<boolean>(false);

  useEffect(() => {
    const contact = getVoiceContact(voiceContact?.getContactId());

    setIsInbound(contact?.isInbound() ?? false);
    setContactQueue(contact?.getQueue().name ?? '');
  }, [voiceContact]);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <InboundIcon color={isInbound ? '#0090E3' : '#FF6600'} rotation={isInbound ? 0 : 180} />
        <Typography color={'#fff'} variant="body" sx={{ marginLeft: '4px' }}>
          {isInbound ? 'Inbound call at:' : 'Outbound call'}
        </Typography>
      </Box>
      {isInbound && (
        <Typography color={'white'} variant="h4">
          {contactQueue}
        </Typography>
      )}
    </Box>
  );
};

export default ContactQueue;
